import { WheelsTimeFilters } from '../../../domain/wheels';
import { LocalStorage } from '../../../utils';

const WHEELS_TIME_FILTERS_KEY = 'wheels-time-filters';

// === Wheels Time Fiilters =================================================

export const storeWheelsTimeFiltersInLocalStorage = (wheelsTimeFilters: WheelsTimeFilters) =>
  LocalStorage.setItem(WHEELS_TIME_FILTERS_KEY, wheelsTimeFilters);

export const getWheelsTimeFiltersFromLocalStorage = (): WheelsTimeFilters =>
  LocalStorage.getItem(WHEELS_TIME_FILTERS_KEY);
